var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseElButton',{staticClass:"add-btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"flex justify-center items-center"},[_c('p',{staticStyle:{"margin-right":"5px"}},[_vm._v(_vm._s(_vm.content))]),_c('MaterialIcon',{attrs:{"size":24}},[_vm._v(" add_outlined ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }